var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailinstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram",
    transform: "translate(-2312 -9111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "instagram-logo-fill-svgrepo-com",
    d: "M35.833,33.934a1.9,1.9,0,1,1-1.9-1.9A1.9,1.9,0,0,1,35.833,33.934Zm4.035-2.611v5.222a3.327,3.327,0,0,1-3.323,3.323H31.323A3.327,3.327,0,0,1,28,36.545V31.323A3.327,3.327,0,0,1,31.323,28h5.222A3.327,3.327,0,0,1,39.868,31.323Zm-3.086,2.611a2.848,2.848,0,1,0-2.848,2.848A2.848,2.848,0,0,0,36.782,33.934Zm.949-3.086a.712.712,0,1,0-.712.712A.712.712,0,0,0,37.732,30.848Z",
    transform: "translate(2290.066 9089.066)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_126",
    "data-name": "Ellipse 126",
    transform: "translate(2312 9111)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.25,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailinstagram);
export default __webpack_public_path__ + "static/media/emailinstagram.0b46f8e9f1d07527bdeb51f9072316d2.svg";
export { ForwardRef as ReactComponent };